import { useEffect } from 'react';
import { ErrorHandler } from './ErrorHandler';

/**
 * Hook to handle listening for `unhandledrejection` events.
 *
 * Delegates entirely to ErrorHandler.handleUnhandledRejection() which
 * converts the event via ErrorConverter, deduplicates, and submits to
 * LogMessage. The useEffect lifecycle ensures proper listener cleanup.
 */
export function useErrorHandling() {
  useEffect(() => {
    const handler = (event: PromiseRejectionEvent) => {
      ErrorHandler.getInstance().handleUnhandledRejection(event);
    };

    window.addEventListener('unhandledrejection', handler, false);

    return () => {
      window.removeEventListener('unhandledrejection', handler);
    };
  }, []);
}
